import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ReportCanvas = ({ selectedTemplate, widgets, onAddWidget, onRemoveWidget }) => {
  const [draggedWidget, setDraggedWidget] = useState(null);

  const handleDragStart = (widget) => {
    setDraggedWidget(widget);
  };

  const handleDragOver = (e) => {
    e?.preventDefault();
  };

  const handleDrop = (e) => {
    e?.preventDefault();
    if (draggedWidget) {
      onAddWidget(draggedWidget);
      setDraggedWidget(null);
    }
  };

  const getWidgetIcon = (type) => {
    switch (type) {
      case 'chart':
        return 'BarChart3';
      case 'table':
        return 'Table';
      case 'kpi':
        return 'Activity';
      case 'map':
        return 'Map';
      default:
        return 'Box';
    }
  };

  return (
    <div className="h-full flex flex-col bg-background">
      <div className="flex items-center justify-between p-4 border-b border-border">
        <div>
          <h3 className="font-semibold text-foreground">Report Canvas</h3>
          {selectedTemplate && (
            <p className="text-sm text-muted-foreground">{selectedTemplate?.name}</p>
          )}
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" iconName="Eye">
            Preview
          </Button>
          <Button variant="default" size="sm" iconName="Save">
            Save Report
          </Button>
        </div>
      </div>
      <div
        className="flex-1 p-6 overflow-y-auto custom-scrollbar"
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        {widgets?.length === 0 ? (
          <div className="h-full flex flex-col items-center justify-center text-center">
            <div className="w-20 h-20 rounded-full bg-muted/50 flex items-center justify-center mb-4">
              <Icon name="Layout" size={40} color="var(--color-muted-foreground)" />
            </div>
            <h4 className="text-lg font-semibold text-foreground mb-2">
              Start Building Your Report
            </h4>
            <p className="text-sm text-muted-foreground max-w-md mb-4">
              Drag and drop widgets from the right panel to create your custom report layout
            </p>
            <Button variant="outline" iconName="Plus">
              Add Widget
            </Button>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-4">
            {widgets?.map((widget, index) => (
              <div
                key={index}
                className="relative p-4 rounded-lg border border-border bg-card hover:shadow-md transition-shadow"
              >
                <button
                  onClick={() => onRemoveWidget(index)}
                  className="absolute top-2 right-2 w-6 h-6 rounded-full bg-destructive/10 hover:bg-destructive/20 flex items-center justify-center transition-colors"
                  aria-label="Remove widget"
                >
                  <Icon name="X" size={14} color="var(--color-destructive)" />
                </button>
                <div className="flex items-center gap-2 mb-3">
                  <Icon name={getWidgetIcon(widget?.type)} size={20} color="var(--color-primary)" />
                  <h4 className="font-semibold text-sm text-foreground">{widget?.title}</h4>
                </div>
                <div className="h-40 bg-muted/30 rounded flex items-center justify-center">
                  <span className="text-xs text-muted-foreground">{widget?.type} visualization</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportCanvas;